import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["formTemplate", "formWrapper"]
  connect() {
    // console.log('hello question-option')
  }

  add(event) {
    event.preventDefault()
    // console.log(event.currentTarget.dataset)
    const form = this.formTemplateTarget.cloneNode(true);
    // Remove all insert field targets from the cloned form
    form.removeAttribute("data-question-option-target");
    form.querySelectorAll('[data-question-option-target]').forEach(el => {
      el.removeAttribute("data-question-option-target")
    })

    const newPosition = this._getOptionIndex()
    const newIndex = newPosition - 1

    // TODO - need to check whether there is "is_other" option
    const isOtherField = this._checkIsOtherExists()
    // console.log('isOtherField', isOtherField)

    // console.log('form', form)
    form.querySelectorAll('[id*="NEW_INDEX"], [name*="NEW_INDEX"]').forEach(element => {
      element.id = element.id.replace('NEW_INDEX', newIndex);
      element.name = element.name.replace('NEW_INDEX', newIndex);
      if (element.name.includes('position')) {
        element.value = isOtherField ? newPosition - 1 : newPosition;
      }
    });

    form.classList.remove("hidden");
    // console.log('this.formTemplateTarget', this.formTemplateTarget)
    if (isOtherField) {
      // position update will be handled HERE AND in the backend
      isOtherField.querySelector('input[name*="position"]').value = newPosition
      isOtherField.parentNode.insertBefore(form, isOtherField)
    } else {
      this.formTemplateTarget.insertAdjacentElement("beforebegin", form);
    }
  }

  addOther(event) {
    event.preventDefault()
    // console.log(event.currentTarget.dataset)
    const form = this.formTemplateTarget.cloneNode(true);
    // Remove all insert field targets from the cloned form
    form.removeAttribute("data-question-option-target");
    form.querySelectorAll('[data-question-option-target]').forEach(el => {
      el.removeAttribute("data-question-option-target")
    })

    // console.log('form', form)
    const newPosition = this._getOptionIndex()
    const newIndex = newPosition - 1
    form.querySelectorAll('[id*="NEW_INDEX"], [name*="NEW_INDEX"]').forEach(element => {
      element.id = element.id.replace('NEW_INDEX', newIndex);
      element.name = element.name.replace('NEW_INDEX', newIndex);
      if (element.name.includes('position')) {
        element.value = newPosition;
      }
      if (element.name.includes('is_other')) {
        element.value = true;
      }
      if (element.name.includes('content')) {
        element.value = 'Other (Please specify)';
        element.readOnly = true;
      }
      if (element.name.includes('content_cn')) {
        element.value = '其他（请描述）';
        element.readOnly = true;
      }
    });

    form.classList.remove("hidden");
    // console.log('this.formTemplateTarget', this.formTemplateTarget)
    this.formTemplateTarget.insertAdjacentElement("beforebegin", form);
    this._toggleAddOtherButton()
  }

  remove(e) {
    // console.log(e.currentTarget)
    const el = e.currentTarget
    // console.log(e.currentTarget.querySelector('input[name*="_destroy"]'))
    const destroyField = el.querySelector('input[name*="_destroy"]')
    if (destroyField) {
      el.parentNode.parentNode.classList.add('hidden')
      destroyField.value = 'true'
    }
    if (e.currentTarget.parentNode.parentNode.querySelector('input[name*="is_other"]')) {
      this._toggleAddOtherButton()
    }
  }

  // PRIVATE METHODS
  _checkIsOtherExists() {
    const fields = this.element.querySelectorAll('.option-fields')
    let isOtherField;
    fields.forEach(field => {
      const isOther = field.querySelector('input[name*="is_other"]')?.value === 'true'
      if (isOther) {
        isOtherField = field //.querySelector('input[name*="position"]')
      }
    })
    // should return the entire field
    return isOtherField
  }

  _getOptionIndex() {
    const fields = this.element.querySelectorAll('.option-fields')
    // console.log('fields count', fields.length)
    return fields.length
  }

  _toggleAddOtherButton(field) {
    const addOtherButton = this.element.querySelector('#add-other-button')
    addOtherButton.classList.toggle('hidden')
  }

  // Retiring this code, positional changes will be handled in the backend
  // _replaceIsOtherField(newField, existingOtherField) {
  //   // TODO - I WANT A BETTER WAY TO DO THIS
  //   console.log('newField', newField)
  //   console.log('existingOtherField', existingOtherField)
  //   console.log(`newField.querySelector('input[name*="is_other"]')`, newField.querySelector('input[name*="is_other"]'))
  //   newField.querySelector('input[name*="is_other"]').value = 'true'
  //   newField.querySelector('input[name*="content"]').value = 'Other'
  //   newField.querySelector('input[name*="content_cn"]').value = '其他'
  //   newField.querySelector('input[name*="content"]').readOnly = true
  //   newField.querySelector('input[name*="content_cn"]').readOnly = true

  //   existingOtherField.querySelector('input[name*="is_other"]').value = 'false'
  //   existingOtherField.querySelector('input[name*="content"]').value = ''
  //   existingOtherField.querySelector('input[name*="content_cn"]').value = ''
  //   existingOtherField.querySelector('input[name*="content"]').readOnly = false
  //   existingOtherField.querySelector('input[name*="content_cn"]').readOnly = false
  // }
}
